var render, staticRenderFns
import script from "./Ava.vue?vue&type=script&lang=ts"
export * from "./Ava.vue?vue&type=script&lang=ts"
import style0 from "./Ava.vue?vue&type=style&index=0&id=77cd7bff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cd7bff",
  null
  
)

export default component.exports